import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import RequestState from 'Enums/RequestState'
import InfinityEnums from 'Enums/InfinityEnums'
import OperatorUserActionList from 'Containers/OperatorUserActionList/OperatorUserActionList'
import OperatorUserActionsAction from 'Stores/OperatorUserActions/Actions'
import OperatorUserActionsSelectors from 'Stores/OperatorUserActions/Selectors'
import Styles from './OperatorUserActionsChargingToken.module.css'

const OperatorUserActionsChargingToken = ({
  operatorUserActionsChargingToken,
  fetchOperatorUserActionsChargingTokenRequestState,
  operatorUserActionsChargingTokenPaginationOffset,
  fetchOperatorUserActionsChargingToken,
  operatorUserActionsFilters,
  selectedCard,
  selectedDetails,
}) => {
  useEffect(() => {
    if (selectedCard && selectedDetails === 1) {
      fetchOperatorUserActionsChargingToken(selectedCard._id, null, 0)
    }
  }, [selectedDetails])

  const loadMoreData = () => {
    if (
      fetchOperatorUserActionsChargingTokenRequestState ===
      RequestState.LOADING_MORE
    )
      return
    fetchOperatorUserActionsChargingToken(
      selectedCard._id,
      operatorUserActionsFilters,
      operatorUserActionsChargingTokenPaginationOffset,
    )
  }

  const handleRetryOperatorUserActions = () => {
    fetchOperatorUserActionsChargingToken(
      selectedCard._id,
      operatorUserActionsFilters,
      operatorUserActionsChargingTokenPaginationOffset,
    )
  }

  return (
    <div className={Styles.container}>
      <OperatorUserActionList
        operatorUserActions={operatorUserActionsChargingToken}
        paginationOffset={operatorUserActionsChargingTokenPaginationOffset}
        fetchOperatorUserActionsRequestState={
          fetchOperatorUserActionsChargingTokenRequestState
        }
        operatorUserActionsType={InfinityEnums.Models.ChargingToken}
        loadMoreData={() => loadMoreData()}
        handleRetry={() => handleRetryOperatorUserActions()}
      />
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    fetchOperatorUserActionsChargingToken: (chargingTokenId, filter, offset) =>
      dispatch(
        OperatorUserActionsAction.fetchOperatorUserActionsChargingToken(
          chargingTokenId,
          filter,
          offset,
        ),
      ),
  }
}

const mapStateToProps = (state) => ({
  operatorUserActionsChargingToken:
    OperatorUserActionsSelectors.getOperatorUserActionsChargingToken(state),
  fetchOperatorUserActionsChargingTokenRequestState:
    OperatorUserActionsSelectors.getFetchOperatorUserActionsChargingTokenRequestState(
      state,
    ),
  operatorUserActionsChargingTokenPaginationOffset:
    OperatorUserActionsSelectors.getOperatorUserActionsChargingTokenPaginationOffset(
      state,
    ),
  operatorUserActionsFilters:
    OperatorUserActionsSelectors.getOperatorUserActionsFilters(state),
})

OperatorUserActionsChargingToken.propTypes = {
  operatorUserActionsChargingToken: PropTypes.array,
  fetchOperatorUserActionsChargingTokenRequestState: PropTypes.string,
  operatorUserActionsChargingTokenPaginationOffset: PropTypes.number,
  fetchOperatorUserActionsChargingToken: PropTypes.func,
  operatorUserActionsFilters: PropTypes.array,
  selectedCard: PropTypes.object,
  selectedDetails: PropTypes.number,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OperatorUserActionsChargingToken)
